export const messageNameKey = 'Message Name';

export const trackViewedInAppAnnouncement = (messageName: string) => ({
  event: 'Viewed In-App Announcement',
  '[Message Name]': messageName,
});
